import api from "./request";

const vuePlugin = function (app) {
  if (vuePlugin.installed) {
    return;
  }
  vuePlugin.installed = true;
  app.config.globalProperties.$api = api;
};
export { api, vuePlugin };
export default api;
